import * as React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators, Dispatch } from 'redux'
import {Redirect} from 'react-router-dom'
import * as actionCreators from "../../action-creators"
import BasePage, { Props as BaseProps } from '../base-page'
import * as Toolbar from "../toolbar"
import { hasProfile, Profile } from '../../domain/sfp/user-domain'
import * as UserDomain from "../../domain/sfp/user-domain"
import { ReducerState } from '../../reducer'
import * as routes from '../../util/routes'

class Dashboard extends BasePage<InjectedProps> {
	protected editingProfiles: UserDomain.Profile[] = []
	protected viewingProfiles: UserDomain.Profile[] = []
	protected toolbar?: Toolbar.ToolbarItem[]
	protected renderPageContent(): React.ReactNode {
		return
	}

	render() {
		const currentUser = this.props.currentUser
		const localAuthoritySlug = this.props.currentLocalAuthority
		? this.props.currentLocalAuthority.slug : null

		if (localAuthoritySlug && currentUser && hasProfile(currentUser, Profile.ServiceAgent))
			return <Redirect to={localAuthoritySlug + routes.PROJECTION_COUNTERS}/>

		return <Redirect to={routes.USERS}/>
	}
}

const mapStateToProps = (state: ReducerState) => state;
const mapDispatchToProps = (dispatch: Dispatch<ReducerState>) => (
	{ actions: bindActionCreators(actionCreators, dispatch) }
);

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);

export interface Props extends BaseProps {}

type InjectedProps = Props & ReducerState



// WEBPACK FOOTER //
// ./src/component/dashboard/index.tsx